import React, { Component } from 'react';
import anime from 'animejs';

import "./chat.css";

import MessageGroup from "../components/message-group.js";
// import Message from "../components/message.js";
// import LineHistogram from "../components/input/line-histogram.js";
// import BarChart from "../components/input/bar-chart.js";
// import Button from 'material-ui/Button';

class Chat extends Component {
  constructor(props) {
    super(props)

    this.state = {
      step: 1,
      hideError: false,
      hasLoadingBubble: false
    }

    this.addMessage = this.addMessage.bind(this);
    this.increaseStep = this.increaseStep.bind(this);
  }

  componentDidMount() {
    anime({
      targets: "#chat-container",
      opacity: [0,1],
      duration: 800,
      delay: 200,
      easing: 'easeInQuad',
    })
  }

  // componentDidUpdate() {
  //   const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  //   // console.log(this.container.clientHeight, this.container.offsetTop, h)
  //   const scrollable = this.container.clientHeight + this.container.offsetTop > h
  //   const hasCurrentGroup = this.props.messageGroup
  //   if (scrollable && hasCurrentGroup) {
  //     console.log("scrolling")
  //     Scroll.animateScroll.scrollToBottom({ duration: 1000 });
  //   }
  // }

  addMessage(answer) {
    // this.setState({ step: 1, hideError: false })
    this.props.addMessage(answer)
  }

  componentWillReceiveProps(nextProps) {
    // console.log("recv props", nextProps)

    const sameGroup = !!nextProps.messageGroup && this.props.messageGroup && nextProps.messageGroup.id === this.props.messageGroup.id
    const previousGroup = nextProps.messageGroup && this.props.messageHistory.map(g => g.id).some(id => id === nextProps.messageGroup.id)

    // console.log(sameGroup, previousGroup)

    const hasLoadingBubble = this.props.loading && (!this.props.messageGroup || this.props.messageGroup.userMessage)

    const newState = { hasLoadingBubble: hasLoadingBubble }
    if (!sameGroup && !previousGroup) {
      this.setState(Object.assign(newState, { step: 1 }))
    } else if (previousGroup) {
      this.setState(Object.assign(newState, { step: 50, hideError: false }))
    } else {
      this.setState(newState)
    }

    
  }

  increaseStep(event) {
    if (this.props.completed) return

    event.stopPropagation();

    // console.log("inc step", event)

    this.setState((prevState) => {
      return {
        step: prevState.step + 1,
        hideError: true
      }
    })
  }

  render() {
    const messageGroups = this.props.messageHistory.slice() || []
    if (this.props.messageGroup) {
      let group = Object.assign({}, this.props.messageGroup)
      if (group.systemMessages.length >= this.state.step) {
        group.input = null  // disable input if step isn't far enough.
      }
      group.systemMessages = group.systemMessages.slice(0, this.state.step)  // limit to messages up to current step.
      group.errorMessage = this.state.hideError ? null : this.props.errorMessage
      messageGroups.push(group)
    }

    if (this.props.loading && messageGroups.every(grp => grp.userMessage)) {
      messageGroups.push({
        id: "loading",
        loading: true,
        systemMessages: []
      })
    }

    messageGroups.forEach(grp => {
      grp.systemMessages.forEach((msg, i) => {
        msg['id'] = grp.id + "-" + i
      })
      if (grp.userMessage) grp.userMessage['id'] = grp.id + "-user"
    })

    // console.log("RENDERING CHAT", this.props, messageGroups)

    const loadingEl = document.getElementById("message-loading")
    // if (loadingEl) console.log(loadingEl.style)
    const hasLoadingBubble = loadingEl && +loadingEl.style.opacity > 0.3
    const noAnimationIndex = messageGroups.length - 1

    const classNames = "chat-container" + (this.props.completed ? "" : " active")
    return (
      <div id="chat-container" className={classNames} onClick={this.increaseStep}>
        <div className="progress-indicator" style={{width: this.props.percentComplete + "%"}} />
        {/*<div style={{ height: "100%", width: "100%", position: "absolute", top: 0, left: 0}} onClick={this.increaseStep}/>*/}
        <div id="scroll-content" className="scroll-content">
          <div className="chat-column">
          {/* TODO: Insert components to test here! */}
          {
            messageGroups
              .map((group, index) => {
                return (
                  <MessageGroup key={group.id}
                    {...group} 
                    id={"message-group-" + group.id} 
                    addMessage={this.props.addMessage}
                    noAnimation={index < noAnimationIndex}
                    noAvatar={index < messageGroups.length - 1}
                    hasLoadingBubble={hasLoadingBubble}
                  />
                )
              })
          }
          {/*{ !this.props.messageGroup && !this.props.completed && <div className="input-placeholder" /> }*/}
          </div>
        </div>
      </div>
    )
  }
}

// export default AutoScroll({ property: 'messages' })(Chat);
export default Chat;


// WEBPACK FOOTER //
// ./src/components/chat.js